module.exports = __webpack_public_path__ + "static/img/female-bg-id.bf4e9a02.png";